import {
  Milestone,
  UniUserEventProgress,
  UserGlobalEventProgress,
} from '@wwe-portal/entities/rbe.type';

export const getCurrentMilestone = (
  milestones: Milestone[],
  point?: number
) => {
  if (point == null || point === 0) {
    return milestones[0];
  }

  return (
    milestones.find((item) => item.requirement > point) ??
    milestones[milestones.length - 1]
  );
};

export const isGlobalEventProgress = (
  userProgress: UniUserEventProgress | undefined
): userProgress is UserGlobalEventProgress => {
  return userProgress != null && 'userPoint' in userProgress;
};

export const getUserEventPoints = (
  userProgress: UniUserEventProgress | undefined
) => {
  return isGlobalEventProgress(userProgress)
    ? userProgress.userPoint
    : userProgress?.point;
};

export const countEventParticipant = (
  userProgress: UniUserEventProgress | undefined
) => {
  return isGlobalEventProgress(userProgress)
    ? userProgress.participantsCount
    : undefined;
};
